import { Injectable } from '@angular/core';

export interface ILogProvider {
  toLog: () => any;
}

@Injectable({ providedIn: 'root' })
export class LoggingService {
  private static readonly PREFIX = 'kp';

  debug(className: string, message: string, value: any) {
    console.debug(this.formatMessage(className, message, value));
  }

  log(className: string, message: string, value: any) {
    console.log(this.formatMessage(className, message, value));
  }

  warn(className: string, message: string, value: any) {
    console.warn(this.formatMessage(className, message, value));
  }

  error(className: string, message: string, value: any) {
    console.error(this.formatMessage(className, message, value));
  }

  private formatMessage(className: string, message: string, value: any) {
    try {
      return `${LoggingService.PREFIX}\t${this.timestamp()}\t${className}\t${message}\t${this.stringifyValue(value)}`;
    } catch (err) {
      console.error('Error trying to log message', err);
      return undefined;
    }
  }

  private stringifyValue(value: any): string {
    if (this.isObject(value)) {
      value = this.isLogProvider(value) ? value.toLog() : value;
      return JSON.stringify(value);
    }

    if (this.isArray(value)) {
      return value.map((item: any) => this.stringifyValue(item)).join();
    }

    return value;
  }

  private isObject(value: any): boolean {
    return value && typeof value === 'object';
  }

  private isArray(value: any): boolean {
    return value && Array.isArray(value);
  }

  private timestamp(): string {
    const dateTime = new Date();
    return `${dateTime.getUTCDate()}.${
      dateTime.getUTCMonth() + 1
    }.${dateTime.getUTCFullYear()}T${dateTime.getUTCHours()}:${dateTime.getUTCMinutes()}:${dateTime.getUTCSeconds()}`;
  }

  private isLogProvider(e: any): e is ILogProvider {
    return e && 'toLog' in e && typeof e.toLog === 'function';
  }
}
